export const siteInfo = {
  name: '蚂蚁影视',
  tagline: '每日更新 · 高清不缓冲',
  slogan: '即点即播不缓冲，海量资源随心看',
  description:
    '蚂蚁影视是专注高清免费在线观看的综合性影视平台，涵盖电影、电视剧、综艺、动漫、纪录片等海量内容资源。平台采用先进视频加速技术，实现即点即播不缓冲的流畅观影体验，每日持续更新最新热播影片与经典佳作，是影迷追剧、发现好片的首选观影入口。',
  heroStats: [
    { label: '片库资源', value: '20,000+' },
    { label: '每日更新', value: '50+ 部' },
    { label: '播放成功率', value: '99.9%' },
  ],
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '精选专题', href: '#carousel' },
  { label: '热播榜单', href: '#ranking' },
  { label: '影迷热评', href: '#comments' },
  { label: '联系我们', href: '#contact' },
  { label: '平台优势', href: '#features' },
  { label: '移动观影', href: '#app' },
];

export const comments = [
  {
    id: 1,
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%20casual%20style%20warm%20tone%20cinematic%20lighting%20simple%20background%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '用了蚂蚁影视快两年了，资源真的全！从院线新片到冷门老片基本都能找到，而且加载速度飞快，四五年了没怎么卡过。真心推荐给所有爱看电影的朋友。',
    date: '2026-07-28',
    liked: 1286,
  },
  {
    id: 2,
    name: '电影爱好者小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%20gentle%20smile%20warm%20lighting%20cinematic%20style%20simple%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '之前用其他平台经常缓冲转圈看得心累，换了蚂蚁影视之后体验天差地别。高清画质加上流畅播放，周末连刷一整天剧都不带卡的，简直是我的快乐源泉！',
    date: '2026-07-25',
    liked: 956,
  },
  {
    id: 3,
    name: '影评人老张',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20Chinese%20man%20portrait%20avatar%20intellectual%20look%20warm%20tone%20cinematic%20lighting%20simple%20background%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '作为影评人，我对画质和资源丰富度要求比较高。蚂蚁影视的高清片源质量相当不错，分类也很清晰，找片效率很高。唯一的建议是希望能增加更多经典修复版老电影。',
    date: '2026-07-20',
    liked: 723,
  },
];

export const topics = [
  { id: 1, name: '暑期档热映', count: 38600, trend: 'up' as const },
  { id: 2, name: '悬疑烧脑', count: 29100, trend: 'up' as const },
  { id: 3, name: '国产剧崛起', count: 27400, trend: 'up' as const },
  { id: 4, name: '经典重温', count: 25300, trend: 'up' as const },
  { id: 5, name: '科幻巨制', count: 21800, trend: 'up' as const },
  { id: 6, name: '治愈系动漫', count: 19500, trend: 'up' as const },
  { id: 7, name: '纪录片精选', count: 17200, trend: 'up' as const },
  { id: 8, name: '动作大片', count: 15600, trend: 'up' as const },
  { id: 9, name: '喜剧合集', count: 13400, trend: 'up' as const },
  { id: 10, name: '日韩剧场', count: 11800, trend: 'up' as const },
];

export const cards = [
  {
    id: 1,
    title: '《深海追凶》—— 年度悬疑黑马',
    desc: '深海悬疑大作，层层反转让你猜不到结局，豆瓣开分8.6，悬疑爱好者不容错过的视听盛宴。',
    image: 'https://readdy.ai/api/search-image?query=deep%20ocean%20thriller%20film%20scene%20dark%20blue%20underwater%20mysterious%20atmosphere%20cinematic%20lighting%20dramatic%20composition%20professional%20film%20photography%20with%20deep%20shadows%20and%20underwater%20bubbles&width=720&height=480&seq=card-01&orientation=landscape',
    tag: '悬疑',
    year: '2026',
    rating: 8.6,
  },
  {
    id: 2,
    title: '《星际之门：重启》—— 科幻视效巅峰',
    desc: '硬核科幻重启经典，超震撼视觉特效搭配宏大世界观，带你穿越星际探索未知宇宙的终极秘密。',
    image: 'https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20film%20scene%20star%20portal%20cosmic%20nebula%20golden%20and%20coral%20tones%20cinematic%20lighting%20dramatic%20composition%20professional%20film%20photography%20with%20stunning%20visual%20effects&width=720&height=480&seq=card-02&orientation=landscape',
    tag: '科幻',
    year: '2026',
    rating: 9.1,
  },
  {
    id: 3,
    title: '《长安十二夜》—— 国产古装新标杆',
    desc: '盛唐背景下权谋与情感交织，服化道精良考究，演技派阵容倾情演绎一段荡气回肠的长安传奇。',
    image: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20Tang%20dynasty%20palace%20scene%20warm%20lantern%20light%20elegant%20costume%20drama%20cinematic%20composition%20golden%20hour%20lighting%20traditional%20architecture%20professional%20film%20photography&width=720&height=480&seq=card-03&orientation=landscape',
    tag: '古装',
    year: '2026',
    rating: 9.3,
  },
  {
    id: 4,
    title: '《外卖人生》—— 现实主义高分喜剧',
    desc: '聚焦外卖骑手的接地气喜剧，笑中带泪的都市生活图鉴，平凡人生中的不平凡感动，年度口碑佳作。',
    image: 'https://readdy.ai/api/search-image?query=modern%20Chinese%20city%20street%20scene%20warm%20evening%20light%20urban%20life%20cinematic%20composition%20neon%20signs%20and%20street%20food%20atmosphere%20realistic%20drama%20film%20photography%20with%20warm%20golden%20tones&width=720&height=480&seq=card-04&orientation=landscape',
    tag: '喜剧',
    year: '2026',
    rating: 8.9,
  },
  {
    id: 5,
    title: '《山海经：洪荒纪元》—— 国漫之光',
    desc: '取材山海经神话体系，国风美学拉满的动画巨制，每一帧都是精美壁纸，展现中国动画的无限可能。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20animated%20film%20scene%20fantastical%20creatures%20mystical%20mountain%20landscape%20ink%20wash%20painting%20style%20ethereal%20atmosphere%20warm%20golden%20and%20jade%20tones%20cinematic%20composition&width=720&height=480&seq=card-05&orientation=landscape',
    tag: '动漫',
    year: '2026',
    rating: 9.0,
  },
];

export const contactInfo = {
  title: '影迷投稿 & 资源合作',
  desc: '欢迎影评投稿、影片推荐、资源合作与商务洽谈。蚂蚁影视始终以开放姿态接纳优质内容创作者与合作伙伴。',
  email: 'contact@mayiying.com',
  tips: ['影评文章投稿', '影片资源合作', '商务推广合作', '技术问题反馈'],
};

export const carouselItems = [
  {
    id: 1,
    title: '2026 暑期档 · 热映大片专题',
    desc: '盘点今年暑期档必看大片，从国产巨制到好莱坞引进，覆盖动作、悬疑、动画全类型，一站式掌握盛夏观影指南。',
    image: 'https://readdy.ai/api/search-image?query=summer%20cinema%20blockbuster%20movie%20poster%20collage%20warm%20golden%20sunset%20light%20dramatic%20cinematic%20composition%20film%20reel%20and%20popcorn%20atmosphere%20professional%20movie%20theater%20photography&width=800&height=500&seq=carousel-01&orientation=landscape',
    label: '热门策划',
    color: 'primary' as const,
  },
  {
    id: 2,
    title: '悬疑片单 · 全程高能无尿点',
    desc: '精选国内外高分悬疑佳作，从密室推理到社会派悬疑，每部都能让你屏息凝神看到最后一秒，烧脑爱好者速来。',
    image: 'https://readdy.ai/api/search-image?query=mystery%20thriller%20film%20atmosphere%20dark%20rainy%20city%20street%20noir%20style%20cinematic%20lighting%20with%20shadows%20and%20fog%20professional%20film%20photography%20moody%20and%20suspenseful&width=800&height=500&seq=carousel-02&orientation=landscape',
    label: '片单推荐',
    color: 'accent' as const,
  },
  {
    id: 3,
    title: '国产剧年度盘点 · 口碑与热度齐飞',
    desc: '从古装权谋到现代职场，从家庭伦理到青春校园，盘点本年度评分最高、讨论最热的国产电视剧，追剧不踩雷。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20collage%20ancient%20and%20modern%20costume%20warm%20lighting%20elegant%20composition%20traditional%20and%20contemporary%20Chinese%20aesthetic%20cinematic%20photography%20rich%20colors&width=800&height=500&seq=carousel-03&orientation=landscape',
    label: '年度盘点',
    color: 'secondary' as const,
  },
  {
    id: 4,
    title: '动画世界 · 一部就是一整个宇宙',
    desc: '从宫崎骏经典到国产动画新势力，从皮克斯温暖故事到独立动画短片，这里是成年人的童话避难所和想象力乐园。',
    image: 'https://readdy.ai/api/search-image?query=animated%20film%20beautiful%20fantasy%20world%20colorful%20dreamy%20landscape%20Studio%20Ghibli%20style%20soft%20warm%20lighting%20magical%20atmosphere%20cinematic%20composition%20whimsical%20and%20enchanting&width=800&height=500&seq=carousel-04&orientation=landscape',
    label: '动画专题',
    color: 'primary' as const,
  },
  {
    id: 5,
    title: '纪录片之窗 · 真实世界的万花筒',
    desc: '自然奇观、人文历史、科技前沿、社会纪实——精选全球顶级纪录片，用真实的镜头语言打开你从未见过的世界。',
    image: 'https://readdy.ai/api/search-image?query=nature%20documentary%20film%20scene%20vast%20landscape%20golden%20hour%20light%20majestic%20mountains%20and%20wildlife%20cinematic%20aerial%20photography%20National%20Geographic%20style%20warm%20earth%20tones&width=800&height=500&seq=carousel-05&orientation=landscape',
    label: '纪录精选',
    color: 'accent' as const,
  },
];

export const mediaCards = [
  {
    id: 1,
    title: '《深海追凶》幕后特辑',
    desc: '导演携主创团队深度揭秘水下拍摄的挑战与幕后故事，从剧本到成片的创作全记录。',
    duration: '12:35',
    image: 'https://readdy.ai/api/search-image?query=film%20making%20behind%20the%20scenes%20underwater%20shooting%20set%20professional%20camera%20equipment%20blue%20tone%20water%20reflections%20cinematic%20lighting%20crew%20at%20work%20documentary%20style&width=640&height=360&seq=media-01&orientation=landscape',
    category: '幕后花絮',
  },
  {
    id: 2,
    title: '对话《长安十二夜》美术指导',
    desc: '揭秘盛唐场景的搭建过程，从服饰纹样到宫殿布局的每一处匠心细节，还原真正的大唐气象。',
    duration: '18:22',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20film%20set%20design%20Tang%20dynasty%20palace%20interior%20golden%20warm%20lantern%20light%20elaborate%20costumes%20and%20props%20artistic%20composition%20behind%20the%20scenes&width=640&height=360&seq=media-02&orientation=landscape',
    category: '主创访谈',
  },
  {
    id: 3,
    title: '豆瓣9分动画电影混剪',
    desc: '精选近十年豆瓣评分9.0以上的动画电影经典片段，一次感受全球顶级动画的视听美学盛宴。',
    duration: '06:48',
    image: 'https://readdy.ai/api/search-image?query=animated%20film%20montage%20colorful%20beautiful%20scenes%20from%20famous%20animation%20movies%20warm%20magical%20atmosphere%20cinematic%20composition%20soft%20dreamy%20lighting%20artistic%20photography&width=640&height=360&seq=media-03&orientation=landscape',
    category: '精彩混剪',
  },
];

export const indexItems = [
  {
    id: 1,
    title: '动作冒险',
    desc: '拳拳到肉的动作大片与惊险刺激的冒险故事',
    icon: 'ri-sword-line',
    count: 2860,
  },
  {
    id: 2,
    title: '悬疑推理',
    desc: '烧脑反转、扣人心弦的悬疑佳作合集',
    icon: 'ri-search-eye-line',
    count: 1540,
  },
  {
    id: 3,
    title: '科幻奇幻',
    desc: '脑洞大开的科幻想象与瑰丽奇幻的世界构建',
    icon: 'ri-rocket-line',
    count: 1820,
  },
  {
    id: 4,
    title: '喜剧搞笑',
    desc: '轻松解压的欢乐喜剧与幽默短剧',
    icon: 'ri-emotion-laugh-line',
    count: 2130,
  },
  {
    id: 5,
    title: '爱情浪漫',
    desc: '甜蜜动人的爱情故事与温情治愈的浪漫佳作',
    icon: 'ri-heart-line',
    count: 1690,
  },
  {
    id: 6,
    title: '恐怖惊悚',
    desc: '肾上腺素飙升的惊悚体验与氛围恐怖',
    icon: 'ri-ghost-line',
    count: 980,
  },
  {
    id: 7,
    title: '纪录纪实',
    desc: '真实世界的精彩纪录与深度纪实作品',
    icon: 'ri-camera-lens-line',
    count: 1240,
  },
];

export const rankingItems = [
  {
    id: 1,
    rank: 1,
    title: '《长安十二夜》',
    type: '古装剧',
    hot: 98600,
    change: 'up' as const,
    desc: '盛唐权谋巨制，服化道天花板',
  },
  {
    id: 2,
    rank: 2,
    title: '《星际之门：重启》',
    type: '科幻片',
    hot: 92300,
    change: 'up' as const,
    desc: '硬核科幻回归，视效炸裂',
  },
  {
    id: 3,
    rank: 3,
    title: '《深海追凶》',
    type: '悬疑片',
    hot: 88500,
    change: 'new' as const,
    desc: '深海密室谜案，反转不断',
  },
  {
    id: 4,
    rank: 4,
    title: '《外卖人生》',
    type: '喜剧片',
    hot: 84100,
    change: 'up' as const,
    desc: '现实主义喜剧，笑泪交织',
  },
  {
    id: 5,
    rank: 5,
    title: '《山海经：洪荒纪元》',
    type: '动画片',
    hot: 79600,
    change: 'new' as const,
    desc: '国漫里程碑，东方奇幻美学',
  },
];

export const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '即点即播不缓冲',
    desc: '采用智能CDN加速与P2P传输技术，无论高峰期还是深夜，高清画质即时加载，告别缓冲转圈的烦恼，享受丝滑观影体验。',
  },
  {
    id: 2,
    icon: 'ri-movie-2-line',
    title: '海量片库每日更新',
    desc: '覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容，20000+ 资源库持续扩充，每日更新50+部新片，总有你想看的。',
  },
  {
    id: 3,
    icon: 'ri-device-line',
    title: '全终端无缝切换',
    desc: '支持电脑、平板、手机多终端同步观看记录，在家大屏追剧、通勤手机看片，观影进度自动同步，想在哪看就在哪看。',
  },
];

export const appEntry = {
  title: '蚂蚁影视 · 移动端',
  desc: '随时随地，高清观影不设限。蚂蚁影视移动端适配手机与平板设备，支持投屏到电视大屏，通勤路上、旅行途中、睡前时光，好片从不缺席。',
  badges: ['iOS 客户端', 'Android 客户端', 'iPad 适配', '投屏支持'],
  qrImage: 'https://readdy.ai/api/search-image?query=minimalist%20QR%20code%20design%20with%20warm%20golden%20tones%20clean%20simple%20digital%20pattern%20on%20light%20background%20high%20contrast%20professional%20quality&width=240&height=240&seq=qr-code&orientation=squarish',
};

export const faqItems = [
  {
    id: 1,
    question: '蚂蚁影视真的完全免费吗？',
    answer: '是的，蚂蚁影视目前所有内容完全免费观看，无需充值或订阅会员。我们通过广告合作维持平台运营，保证为用户提供持续稳定的免费观影服务。',
  },
  {
    id: 2,
    question: '为什么有些影片加载很快，有些较慢？',
    answer: '加载速度受片源服务器、您的网络环境和当前观看人数影响。热门影片我们部署了更多CDN节点确保流畅，冷门影片首次加载可能需要稍等片刻，我们正持续优化所有片源的加速节点覆盖。',
  },
  {
    id: 3,
    question: '支持哪些设备观看？可以投屏吗？',
    answer: '支持所有主流设备：PC、Mac、iPhone、iPad、Android手机和平板。移动端支持DLNA和AirPlay投屏功能，可以将影片投射到智能电视上享受大屏观影。',
  },
  {
    id: 4,
    question: '影片的清晰度怎么样？支持哪些画质？',
    answer: '大部分影片提供720P、1080P高清和4K超清多种画质选择，根据您的网络状况自动推荐最佳画质，也可手动切换。新上线热门影片优先提供高清以上片源。',
  },
  {
    id: 5,
    question: '如何反馈影片无法播放或内容问题？',
    answer: '您可以通过页面底部的联系我们入口提交反馈，或发送邮件至指定邮箱。我们通常会在24小时内处理播放异常问题，感谢您的理解与支持。',
  },
];

export const aboutInfo = {
  title: '关于蚂蚁影视',
  paragraphs: [
    '蚂蚁影视成立于2024年，是一支由资深影视爱好者和技术工程师组成的团队，致力于打造国内领先的高清免费在线观影平台。我们相信，好电影应该被更多人看到，优质的观影体验不应该被付费墙阻隔。',
    '平台现已积累超过两万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类，日均服务数百万影迷用户。我们采用先进的智能分发技术，确保每一位用户都能享受到流畅、高清的观影体验。',
    '未来，蚂蚁影视将持续扩大片库覆盖范围，引入更多独家合作内容，并不断优化播放技术，让"即点即播不缓冲"成为每一位用户的日常。你的每一次观看，都是我们前进的动力。',
  ],
};

export const updateItems = [
  {
    id: 1,
    date: '2026-07-30',
    title: '暑期档专题全新上线',
    content: '「2026暑期档 · 热映大片专题」正式上线，涵盖暑期全部热门院线新片与流媒体独家内容，一次看遍盛夏好片。',
    tag: '专题',
  },
  {
    id: 2,
    date: '2026-07-25',
    title: '播放引擎升级至 v3.2',
    content: '全新播放引擎上线，P2P加速效率提升40%，4K画质下平均首帧加载时间缩短至1.2秒，大幅优化高峰期观影体验。',
    tag: '技术',
  },
  {
    id: 3,
    date: '2026-07-18',
    title: '片库突破 20,000 部',
    content: '平台影视资源总数正式突破两万大关，新增500+部经典修复版港片与200+部高清纪录片，片库丰富度再上新台阶。',
    tag: '更新',
  },
  {
    id: 4,
    date: '2026-07-10',
    title: '移动端全新改版上线',
    content: '移动端界面全面升级，新增夜间模式与手势控制播放功能，投屏稳定性大幅提升，移动观影体验焕然一新。',
    tag: '产品',
  },
  {
    id: 5,
    date: '2026-07-02',
    title: 'AI 智能推荐系统上线',
    content: '基于深度学习的智能推荐系统正式启用，根据观影历史和偏好标签精准推荐影片，帮你发现更多冷门好片。',
    tag: '技术',
  },
  {
    id: 6,
    date: '2026-06-22',
    title: '纪录片频道独立上线',
    content: '纪录片频道从综合频道中独立，新增自然、历史、科技、社会四大分类，引入BBC、国家地理等顶级纪实内容。',
    tag: '内容',
  },
  {
    id: 7,
    date: '2026-06-10',
    title: '社区影评功能开放公测',
    content: '影迷社区功能开始公测，支持发表影评、打分、创建片单与互动讨论，为影迷打造专属交流空间。',
    tag: '社区',
  },
];